<template lang="pug">
.changeAvatar
  vue-avatar(:width='500', :height='500', ref='vueavatar', @vue-avatar-editor:image-ready='onImageReady', :image='objectUrl', :borderRadius='50000', :rotation='rotation', :scale='scale')
  br
  i.fa.fa-info-circle
  |  {{$t("changeAvatar.clickToEdit")}}
  br
  input(type="range", v-model='scale', :width='200', :min='1',:max='10', :step='0.02')
  input(type="range", v-model="rotation", :width='200', :min='0',:max='360', :step='0.02')
  br
  button.btn.btn-primary(v-on:click='saveClicked') {{$t("globals.save")}}
  //- button.btn.btn-default(@click="rotateRight") rot
</template>
<script type="text/javascript">
import {VueAvatar} from 'vue-avatar-editor-improved'

import api from '@/utils/api'
import {success, error} from '@/components/shared/Notify'

export default {
  props: {
    object: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      rotation: 0,
      scale: 1
    }
  },
  components: {
    VueAvatar
  },
  computed: {
    objectUrl () {
      return this.object.picture
    }
  },
  methods: {
    saveClicked () {
      var canvas = this.$refs.vueavatar.getImageScaled()
      api.put('avatar/' + this.object.kind + '/' + this.object.id, {
        imgBase64: canvas.toDataURL('image/png')
      }).then((response) => {
        this.object.picture = response.data.picture
        this.object.hasPicture = true
        success(this._i18n.t('changePicture.notify.success'))
      }).catch((e) => {
        error(this._i18n.t('globals.error'))
      })
    },
    onImageReady () {
      this.scale = 1
      this.rotation = 0
    },
    askAvatar () {
      this.$refs.vueavatar.clicked({})
    }
  },
  watch: {
    object () {
      this.scale = 1
      this.rotation = 0
      this.$refs.vueavatar.loadImage(this.objectUrl)
    },
    rotation () {
      this.rotation = parseFloat(this.rotation)
    },
    scale () {
      this.scale = parseFloat(this.scale)
    }
  }
}
</script>
<style lang="sass">
.changeAvatar 
  display: inline-block
  width: 200px
  canvas
    width: 200px
    height: 200px
</style>



// WEBPACK FOOTER //
// ChangeAvatar.vue?205edc00